import { DataTable } from "@components/DataTable/DataTable"
import type { ColumnDef, ColumnSort } from "@tanstack/react-table"
import type { UseQueryResult } from "@tanstack/react-query"
import { useSortingState } from "@hooks/useSortingState"

type TServiceSummaryInfoSectionProps<TData> = {
  title: string
  account_id: number
  queryHook: (account_id: string) => UseQueryResult<TData[]>
  columns: ColumnDef<TData, unknown>[]
  initialSorting?: ColumnSort[]
}

export const ServiceSummaryInfoSection = <TData,>({
  title,
  account_id,
  queryHook,
  columns,
  initialSorting,
}: TServiceSummaryInfoSectionProps<TData>) => {
  const query = queryHook(String(account_id))
  const sorting = useSortingState(initialSorting)

  return (
    <div>
      <h3>{title}</h3>
      {query.isError ? (
        <div className="tw:text-red-500">
          {`There was an error loading ${title}. Error: ${query.error?.message}`}
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={query.data ?? []}
          pending={query.isPending}
          {...sorting}
        />
      )}
    </div>
  )
}
